export default function AboutSection() {
  return (
    <section id="about" className="relative py-14 md:py-20 bg-background-950">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="flex flex-col lg:flex-row items-start gap-8 md:gap-12">
            <div className="flex-1">
              <p className="text-xs md:text-sm text-primary-400 font-medium tracking-wider uppercase mb-2">About Us</p>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-50 tracking-wide">关于我们</h2>
              <div className="mt-5 space-y-4 text-sm md:text-base text-foreground-500 leading-relaxed">
                <p>
                  妖精视频是一个专注于数字颜色系列内容的综合在线平台。我们汇聚了红桃视频的热门连载、小蓝视频的经典合集、黑桃视频的品质剧场、91视频风格的前沿专题、97视频的超清画质片源以及久久视频的丰富典藏，致力于为数字颜色系列的观众打造一站式的优质观影体验。
                </p>
                <p>
                  平台每日保持高频内容更新，200+部新片上架覆盖所有数字颜色频道。我们的技术团队持续优化播放引擎与CDN分发网络，确保无论在PC端还是移动端，都能享受即点即播、高清流畅的观影服务。妖精视频坚持无广告无弹窗的纯净模式，让每一个观众都能专注于内容本身。
                </p>
              </div>
              <div className="flex flex-wrap gap-4 mt-6">
                <div className="flex items-center gap-2 text-sm text-foreground-400">
                  <i className="ri-checkbox-circle-fill text-accent-400"></i>
                  <span>每日更新 200+</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-foreground-400">
                  <i className="ri-checkbox-circle-fill text-accent-400"></i>
                  <span>10万+ 高清片源</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-foreground-400">
                  <i className="ri-checkbox-circle-fill text-accent-400"></i>
                  <span>全端适配播放</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-foreground-400">
                  <i className="ri-checkbox-circle-fill text-accent-400"></i>
                  <span>无广告纯净模式</span>
                </div>
              </div>
            </div>

            <div className="w-full lg:w-[360px] shrink-0">
              <div className="bg-background-800/40 border border-background-700/30 rounded-lg p-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-lg bg-primary-500/15 flex items-center justify-center text-primary-400 font-heading text-lg">妖</div>
                  <div>
                    <p className="text-sm font-medium text-foreground-200">妖精视频</p>
                    <p className="text-xs text-foreground-600">数字颜色系列平台</p>
                  </div>
                </div>
                <div className="space-y-2 text-sm text-foreground-500">
                  <p className="flex items-center gap-2">
                    <i className="ri-timer-line text-accent-400 text-xs"></i>
                    每日更新，全年无休
                  </p>
                  <p className="flex items-center gap-2">
                    <i className="ri-vidicon-line text-accent-400 text-xs"></i>
                    覆盖全数字颜色频道
                  </p>
                  <p className="flex items-center gap-2">
                    <i className="ri-global-line text-accent-400 text-xs"></i>
                    CDN全球加速网络
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}